// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9c2f62ad","952":"5be70023"}[chunkId] + ".chunk.js";
};